import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type AjaxService from 'lumen/services/ajax';

export interface OtherSystem {
  display_name: string;
  id: number;
}

interface OtherSystemsResponse {
  other_systems: OtherSystem[];
}

export default class HotelSettingsMyotbOtherSystemSelectionRoute extends Route {
  @service declare ajax: AjaxService;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  async model() {
    const otherSystemsResponse = await this.ajax.request<OtherSystemsResponse>(
      '/api/v3/othersystems/',
    );

    return {
      otherSystems: otherSystemsResponse.other_systems,
    };
  }
}
